import { UiTypography } from '@/components/ui/Typography';
import {
  PAYWALL_TIMER_MINUTES,
  SECOND_SELECT_PLAN_SECTION_ID,
  SELECT_PLAN_SECTION_ID,
} from '@/constants';
import { PAYWALL_NOTES } from '@/constants/campaign-notes';
import { webCampaign } from '@/modules/webCampaign';
import { scrollToById } from '@/utils/scrollToById';

import { LimitedTimerHoc } from '../LimitedTimerHoc';

import styles from './FixedTimer.module.scss';

export const FixedTimer = () => {
  const isV2 = webCampaign.setup.paywallNotes.includes(
    PAYWALL_NOTES.FIXED_TIMER_V2,
  );
  const shouldScrollToSecondPlan = webCampaign.setup.paywallNotes.includes(
    PAYWALL_NOTES.FIXED_TIMER_SECOND_PLAN,
  );

  const handleGoPremium = () => {
    const targetId = shouldScrollToSecondPlan
      ? SECOND_SELECT_PLAN_SECTION_ID
      : SELECT_PLAN_SECTION_ID;
    scrollToById(targetId, {
      block: 'center',
    });
  };

  const labelText = isV2 ? 'One-time offer for:' : 'Discount reserved for:';

  return (
    <div className={styles['fixed-timer']}>
      <div className={styles.container}>
        <div className={styles.content}>
          <UiTypography variant="body-medium" color="white">
            {labelText}
          </UiTypography>
          <LimitedTimerHoc timeToExpire={PAYWALL_TIMER_MINUTES * 1000 * 60}>
            {({ minutes, seconds }) => (
              <UiTypography variant="title-large" className={styles.timer}>
                {minutes}:{seconds}
              </UiTypography>
            )}
          </LimitedTimerHoc>
        </div>
        {isV2 ? (
          <button
            onClick={handleGoPremium}
            className={styles['btn-claim-offer']}
            type="button"
          >
            <UiTypography
              variant="label-large"
              color="white"
              className={styles['claim-offer-text']}
            >
              CLAIM OFFER
            </UiTypography>
          </button>
        ) : (
          <button
            onClick={handleGoPremium}
            className={styles['btn-get-plan']}
            type="button"
          >
            GET MY PLAN
          </button>
        )}
      </div>
    </div>
  );
};
